<template>
    <newModal :visible="visible" :on-close="close" :on-close-complete="closeComplete" class="video-modal">
        <div slot="header" v-if="title">
            {{title}}
        </div>
        <div class="rwd-embed">
            <iframe v-if="pageLoaded" id="yt-embed" class="yt_player_iframe" width="640" height="360" :src="embed" allowfullscreen="true" allowscriptaccess="always" frameborder="0"></iframe>
        </div>
    </newModal>
</template>

<script>
import newModal from 'components/new-modal.vue';
    export default {
        components: {
            newModal
        },
        props: {
            embed: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                require: false
            },
            pageLoaded: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                visible: false,
            };
        },
        created() {
            this.addEvents();
        },
        mounted(){
            this.pageLoaded = true;
        },
        methods: {
            addEvents() {
                events.$on('videoModalShow', this.show);
            },
            close() {
                this.visible = false;
                var vid = document.getElementById('yt-embed');
                if (vid){
                    vid.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
                }
                
            },
            closeComplete() {
                this.setBodyScroll(scroll);
            },
            show(args) {
                this.visible = args.status;
                this.setBodyScroll(false);
            },
            setBodyScroll(scroll) {
                if (scroll) {
                    document.body.classList.remove('overflow-hidden');
                } else {
                    document.body.classList.add('overflow-hidden');
                }
            }
        },
    };
</script>

<style lang="scss">
    @import '~@sweetwater/sass-resources/sass';

    /* -- GENERAL -- */

    body.overflow-hidden {
        overflow: hidden;

        /* Organize Media Queries */

        @include media('<=900px') {
            height: 100%;
        }

        @include media('<=small') {
            height: 100%;
        }

        @include media('<=567px') {
            height: 100%;
        }

        @include media('<=xsmall') {
            height: 100%;
        }

        @include media('<=350px') {
            height: 100%;
        }
    }

    .nowrap {
        white-space: nowrap;
    }

    .flexbox .modal__mask {
        height: 100%;
    }

    .video-modal .newModal__header {
        font-weight: 600;
        text-align: left;
    }

    .rwd-embed {
        padding-top: 56%;
        position: relative;
        width: 70vw;
        max-width: 950px;
        embed, iframe {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
        }
    }
    @media screen and (max-width: 720px){
        .video-modal {
            background: rgba(0,0,0,.8)!important;
        }
        .rwd-embed {
            width: 90vw;
            margin: -15px -25px -25px -25px;
        }
    }
</style>
